import React from "react";
import { FormattedMessage } from "react-intl";
import { Tooltip } from "antd";
import { QuestionCircleFilled } from "@ant-design/icons";

export default function ForceRestartHourLabel() {
  return (
    <span>
      <FormattedMessage id="ForceRestartHourLabel.forceRestartHour" defaultMessage="Force Restart Hour [UTC]" />{" "}
      <Tooltip
        placement="top"
        title={
          <FormattedMessage
            id="ForceRestartHourLabel.forceRestartHourUTC"
            defaultMessage="Force Restart Hour selected in UTC time"
          />
        }
      >
        <QuestionCircleFilled />
      </Tooltip>
    </span>
  );
}
